<template>
  <div>
    <v-row class="seofootercontent-image-background ma-0" v-if="getSeoBlock()">
      <v-container class="px-lg-12 pb-md-0 px-6">
        <v-row>
          <v-col class="regular-font pr-lg-8">
            <div v-html="getSeoBlock()"></div>
          </v-col>
        </v-row>
      </v-container>
      <!--<v-container>
        <v-col class="text-center">
          <h2
            class="text-uppercase py-4 mb-0 fontsize-28 font-weight-400 line-height-36"
          >More to Discover</h2>
        </v-col>
        <v-row>
          <v-col cols="12" sm="4" md="4" class="text-center px-6">
            <v-img :src="image18"></v-img>
            <h3
              class="pt-5 text-uppercase fontsize-18 font-weight-regular line-height-21 ls-n015"
            >Finding the one:</h3>
            <p class="fontsize-18 line-height-21 ls-n015">Wedding Invitation: Kate and Kevin</p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="text-center px-6">
            <v-img :src="image19"></v-img>
            <h3
              class="pt-5 text-uppercase fontsize-18 font-weight-regular line-height-21 ls-n015"
            >Wedding etiquette:</h3>
            <p class="fontsize-18 line-height-21 ls-n015">in the Age of Social Media</p>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="text-center px-6">
            <v-img :src="image20"></v-img>
            <h3
              class="pt-5 text-uppercase fontsize-18 font-weight-regular line-height-21 ls-n015"
            >Real weddings:</h3>
            <p class="fontsize-18 line-height-21 ls-n015">Invitation Inspired by Something Borrowed</p>
          </v-col>
        </v-row>
      </v-container>-->
    </v-row>
    <!--<v-container>
      <v-row class="py-12 mb-12">
        <v-col cols="12" sm="6" md="6" lg="6" class="px-6">
          <p
            class="text-uppercase fontsize-18 mb-0 line-height-21 ls-n03"
          >WEDDING Couple’s Stationery Style?</p>
          <p
            class="fontsize-18 line-height-21 ls-n03"
          >Most people don’t consider what an elegant touch couple’s stationery can provide until they begin writing thank you notes for their wedding gifts. Beautiful, personalized stationery oes in factplay a part in maintaining meaningful relationships with those who participated in your wedding experience and continue encouraging thoughtful communication beyond the wedding day. The following ideas can inspire you to enhance your connections with unique and personalized stationery options.</p>

          <p
            class="text-uppercase fontsize-18 mb-0 pt-6 line-height-21 ls-n03"
          >When to Send Save the Dates & Wedding Invitations?</p>
          <p
            class="fontsize-18 line-height-21 ls-n03"
          >As you plan for your special day, you might feel like you’re entering a whole new world — one with its own unique rules and customs that are different from any event you’ve planned before. Oftentimes, this is most noticeable when you’re not sure about how to approach a specific detail, like when to take a particular planning step or send out information to guests. Luckily, you can use this guide as your resource for each step of the way. We break down the standard timeline for all wedding invitation-related correspondence so you know what to expect and how to prepare in the time leading up to your big day.</p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" class="px-6">
          <p
            class="text-uppercase fontsize-18 mb-0 line-height-21 ls-n03"
          >What to Write in a Wedding Thank You Card?</p>
          <p
            class="fontsize-18 line-height-21 ls-n03"
          >Once your wedding’s over, you get the opportunity to show your gratitude to all the special people who gave gifts, dedicated time and attention to your big day, and played a part in your celebration. Start off your new life together by writing and mailing thoughtful thank you notes in a timely manner. This guide can help you find the right words to express your gratitude.</p>

          <p
            class="text-uppercase fontsize-18 mb-0 pt-6 line-height-21 ls-n03"
          >Who Receives a Thank You Card?</p>
          <p
            class="mb-0 fontsize-18 line-height-21 ls-n03"
          >Newlyweds write wedding thank you cards to acknowledge the thought, time, and attention others have devoted to their wedding. That means you have the opportunity to write wedding thanks for people who:</p>
          <p
            class="mb-0 fontsize-18 line-height-21 ls-n03"
          >1) Attend pre-wedding events, such as showers or engagement parties.</p>
          <p
            class="mb-0 fontsize-18 line-height-21 ls-n03"
          >2) Attend the wedding ceremony and reception.</p>
          <p
            class="mb-0 fontsize-18 line-height-21 ls-n03"
          >3) Give gifts or money, even if they couldn’t attend the events.</p>
        </v-col>
      </v-row>
    </v-container>-->
  </div>
</template>
<script>
export default {
  name: "SeoFooterContent",
  //props:["categoryList" ,"blockId"],
  components: {},
  computed: {
    /* categorySeoContent: function() {
      return this.$store.state.block.categorySeoContent;
    },*/
    categoryList: function () {
      return this.$store.state.headerCategoryList.categoryListIdWise;
    },
    categoryId: function () {
      return this.$route.meta.id;
    },
    categorySeoContent: function () {
      return this.$store.state.layout.cmsBlockContent;
    },
  },
  data: () => ({
    image18: require("@/assets/Image 18.png"),
    image19: require("@/assets/Image 19.png"),
    image20: require("@/assets/Image 20.png"),
    //blockId:'178'
  }),
  watch: {
    categoryId() {
      this.getSeoBlock();
    },
    categoryList() {
      this.getSeoBlock();
    },
  },
  methods: {
    getSeoBlock() {
      if (this.categoryList) {
        let attributes = this.categoryList.filter(
          (data) => data.id == this.categoryId
        );
        if (attributes.length > 0) {
          let code = attributes[0].ca.filter(
            (data) => data.ac == "landing_page"
          );
          if (code.length > 0) {
            let cId = parseInt(code[0].v);
            if (this.categorySeoContent.length) {
              let data = this.categorySeoContent.filter((element) => {
                return element.id === cId;
              });
              if (data.length > 0) {
                return data[0].content;
              }
            }
          }
        }
      }
    },
  },
  async created() {
    if (this.categoryId) {
      await this.getSeoBlock();
    }
  },
};
</script>
<style src="./SeoFooterContent.scss" lang="scss" scoped /> 